import { googleKey } from "config/CONSTANTS";
export const BASE_URL = "https://teebica.com/backend/admin";
//export const BASE_URL = "http://127.0.0.1/teebica/admin";

export const urlUserLogin = BASE_URL + "/Main/login";

export const urlGetProfileInfo = BASE_URL + "/Profile/GetProfileInfo";
export const urlUpdateProfileInfo = BASE_URL + "/Profile/UpdateProfileInfo";

export const urlGetDashboardDetail = BASE_URL + "/DashBoard/GetDashboardDetail";

export const urlCreateImage = BASE_URL + "/Image/createImage";
export const urlUpdateImage = BASE_URL + "/Image/updateImage";
export const urlGetImageList = BASE_URL + "/Image/getImageList";
export const urlDeleteImage = BASE_URL + "/Image/deleteImage";
export const urlUpdateImagePosition = BASE_URL + "/Image/updateImagePosition";

export const urlCreateVideo = BASE_URL + "/Video/createVideo";
export const urlUpdateVideo = BASE_URL + "/Video/updateVideo";
export const urlGetVideoList = BASE_URL + "/Video/getVideoList";
export const urlDeleteVideo = BASE_URL + "/Video/deleteVideo";
export const urlUpdateVideoPosition = BASE_URL + "/Video/updateVideoPosition";

export const urlCreateUser = BASE_URL + "/Profile/createUser";
export const urlUpdateUser = BASE_URL + "/Profile/updateUser";
export const urlGetUserList = BASE_URL + "/Profile/getUserList";
export const urlDeleteUser = BASE_URL + "/Profile/deleteUser";